import { SvgIcon, SvgIconProps } from '@mui/material';

export const ProductRefundIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <svg viewBox='0 0 26 26' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M6.5 2.16309L3.25 6.49642V21.6631C3.25 22.2377 3.47827 22.7888 3.8846 23.1951C4.29093 23.6015 4.84203 23.8298 5.41667 23.8298H20.5833C21.158 23.8298 21.7091 23.6015 22.1154 23.1951C22.5217 22.7888 22.75 22.2377 22.75 21.6631V6.49642L19.5 2.16309H6.5Z'
          stroke='currentColor'
          strokeWidth='2.025'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M3.25 6.5H22.75'
          stroke='currentColor'
          strokeWidth='2.025'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M15.9719 12.6603C15.8288 12.2469 15.5675 11.8865 15.2217 11.6256C14.8758 11.3646 14.4612 11.2151 14.0312 11.1962H11.1563C10.5844 11.1962 10.0359 11.4276 9.63155 11.8394C9.22718 12.2513 9 12.8099 9 13.3924C9 13.9748 9.22718 14.5334 9.63155 14.9453C10.0359 15.3572 10.5844 15.5885 11.1563 15.5885H14.0312C14.6031 15.5885 15.1516 15.8199 15.5559 16.2318C15.9603 16.6437 16.1875 17.2023 16.1875 17.7847C16.1875 18.3672 15.9603 18.9258 15.5559 19.3377C15.1516 19.7495 14.6031 19.9809 14.0312 19.9809H11.1563C10.7263 19.962 10.3117 19.8125 9.96581 19.5515C9.61996 19.2906 9.35869 18.9302 9.21563 18.5168M12.5937 7.5V11.1962M12.5937 19.9809V23.5'
          stroke='currentColor'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </svg>
    </SvgIcon>
  );
};
